import { requestedAtlasLevel } from './levels.js';
import type { AtlasLevel } from './levels.js';

export function createAtlasRequestScheduler(options: {
  request: (level: AtlasLevel) => Promise<boolean>;
  supersede: () => void;
  onError?: (error: unknown) => void;
}): { update(screenScale: number): void; destroy(): void } {
  let latestScale: number | undefined;
  let timer: ReturnType<typeof setTimeout> | undefined;
  let destroyed = false;
  const clear = () => { if (timer !== undefined) clearTimeout(timer); timer = undefined; };
  return {
    update(screenScale) {
      if (destroyed || Object.is(screenScale, latestScale)) return;
      latestScale = screenScale;
      clear();
      options.supersede();
      const level = requestedAtlasLevel(screenScale);
      if (level === null) return;
      timer = setTimeout(() => {
        timer = undefined;
        void options.request(level).catch((error: unknown) => options.onError?.(error));
      }, 150);
    },
    destroy() {
      if (destroyed) return;
      destroyed = true;
      clear();
      options.supersede();
    },
  };
}
